import { ThemeDefinition } from "vuetify"
import { COLOR_PALETTE as colors, BRAND_COLORS } from "./colorPalette"
import { StatusObject } from "@/types/Status"
import { UtilityObject } from "@/types/Utility"

const statusColors: StatusObject = {
  normal: colors.green400,
  caution: colors.yellow400,
  critical: colors.red500,
  default: colors.grey600,
  neutral: colors.blue600,
}

const utilityColors: UtilityObject = {
  comms: colors.blue400,
  complaints: colors.yellow400,
  notes: colors.blue200,
  freshdesk: colors.green300,
  junifer: colors.grey200,
  bill: colors.grey500,
  payments: colors.green1000,
  email: colors.white,
  other: colors.white,
  ihd: colors.grey100,
  appointment: colors.grey200,
  case: colors.grey200,
  debt: colors.red400,
}

const energyColors = {
  electric: colors.yellow300,
  gas: colors.blue300,
}

const shades = {
  white: colors.white,
  black: colors.black,
}

export const novaLightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: colors.blue500,
    success: colors.green400,
    "success-highlight": colors.green100,
    warning: colors.yellow300,
    danger: colors.red500,
    error: colors.red800,
    focus: colors.yellow400,
    info: colors.blue500,
    background: colors.white,
    "background-dim": colors.grey50,
    surface: colors.white,
    "surface-dim": colors.grey50,
    "surface-dark": colors.grey250,
    highlight: colors.yellow50,
    border: colors.grey300,
    disabled: colors.grey400,
    inverted: shades.black,
    ...BRAND_COLORS,
    ...utilityColors,
    ...statusColors,
    ...energyColors,
    ...shades,
  },
}

export const novaDarkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    primary: colors.blue500,
    success: colors.green400,
    "success-highlight": colors.green700,
    warning: colors.yellow500,
    danger: colors.red400,
    error: colors.red500,
    focus: colors.yellow400,
    info: colors.blue300,
    background: colors.black,
    "background-dim": colors.black,
    surface: colors.grey900,
    "surface-dim": colors.grey850,
    "surface-dark": colors.grey800,
    highlight: colors.yellow50,
    border: colors.grey800,
    disabled: colors.grey700,
    inverted: shades.white,
    ...BRAND_COLORS,
    ...utilityColors,
    ...statusColors,
    ...energyColors,
    ...shades,
  },
}
